const comingSoonEnabled = false;
const headerConfig = {
  colorClass: 'grey',
  iColorClass: 'p-fibre',
  foreground: '#FFFFFF',
  items: [
    {
      url: '/#Home',
      name: 'Home',
    },
    {
      url: '/#AboutUs',
      name: 'About Us',
    },
    {
      url: '/#Services',
      name: 'Services',
    },
    {
      url: '/#GetInTouch',
      name: 'Contact Us',
    },

    {
      url: 'https://bettercorp.co.za/',
      name: 'BetterCorp',
      button: true,
      buttonClass: 'core',
    },
  ],
  logo: {
    url: '/img/svgs/BetterWebsite-BetterFibre.svg',
    width: 150,
    height: 60,
  },
};
const footerConfig = {
  socialIcons: [
    {
      url: 'https://fb.com/BetterCorp',
      icon: 'fa fa-facebook',
    },
  ],
};
const thisHostname = 'fibre.bettercorp.co.za';

import { ISiteRouter } from '@/ISiteRouter';
import Base from './Base.vue';
import _Home from './Home.vue';
import _Packages from './Packages.vue';
import _ContactUs from './ContactUs.vue';
import _TOS from './TOS.vue';
export default {
  config: {
    companyName: 'BetterFibre',
    companyThemeColour: 'rgb(0, 145, 234)',
    companyDescription: 'BetterFibre is a connectivity services provider',
    companyKeywords: ['bettercorp', 'services', 'south africa', 'better', 'ninja', 'betterninja',
      'betterfibre', 'fibre', 'adsl', 'home', 'business', 'internet', 'ftth', 'fttb', 'uncapped',
      'shaping', 'internet service provider', 'isp', 'internet', 'digital village', 'mweb',
      'afrihost', 'vox', 'telkom', 'openserve', 'vumatel', 'link africa', '123net', 'telecommunications',
      'better', 'leading', 'axxess', 'webafrica', 'vodacom', 'supersonic'],
    companyIcons: {
      'Large': '/bcorp-icons/apple-icon.png',
      '192x192': '/bcorp-icons/android-icon-192x192.png',
      '76x76': '/bcorp-icons/apple-icon-76x76.png',
      '120x120': '/bcorp-icons/apple-icon-120x120.png',
      '152x152': '/bcorp-icons/apple-icon-152x152.png',
      '310x310': '/bcorp-icons/ms-icon-310x310.png',
      '70x70': '/bcorp-icons/ms-icon-70x70.png',
      '150x150': '/bcorp-icons/ms-icon-150x150.png',
    },
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: _Home,
      meta: {
        host: thisHostname,
        comingSoon: comingSoonEnabled,
        base: Base,
        headerConfig: {
          hideOnInitial: true,
          ...headerConfig,
        },
        footerConfig: {
          ...footerConfig,
        },
      },
    },
    // {
    //   path: '/Packages',
    //   name: 'Packages',
    //   component: _Packages,
    //   meta: {
    //     host: thisHostname,
    //     comingSoon: comingSoonEnabled,
    //     base: Base,
    //     headerConfig: {
    //       hideOnInitial: false,
    //       ...headerConfig,
    //     },
    //     footerConfig: {
    //       ...footerConfig,
    //     },
    //   },
    // },
    // {
    //   path: '/ContactUs',
    //   name: 'Contact Us',
    //   component: _ContactUs,
    //   meta: {
    //     host: thisHostname,
    //     comingSoon: comingSoonEnabled,
    //     base: Base,
    //     headerConfig: {
    //       hideOnInitial: false,
    //       ...headerConfig,
    //     },
    //     footerConfig: {
    //       ...footerConfig,
    //     },
    //   },
    // },
    {
      path: '/TOS',
      name: 'Terms of Service',
      component: _TOS,
      meta: {
        host: thisHostname,
        comingSoon: comingSoonEnabled,
        base: Base,
        headerConfig: {
          hideOnInitial: false,
          ...headerConfig,
        },
        footerConfig: {
          ...footerConfig,
        },
      },
    },
    {
      path: '*',
      name: 'Not found',
      component: _Home,
      meta: {
        host: thisHostname,
        comingSoon: comingSoonEnabled,
        base: Base,
        headerConfig: {
          hideOnInitial: false,
          ...headerConfig,
        },
        footerConfig: {
          ...footerConfig,
        },
      },
    },
  ],
} as ISiteRouter;
